<template>
  <div>
    <base-crud
      crudName="Administradores"
      newText="Novo Administrador"
      :table="adminTable"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="true"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function() {
    return {
      adminTable: "adminTable",
      admins: [],
      pages: [],
      url: "",
      columns: ["id", "name", "email", "actions"],
      tableData: ["id", "name", "email"],
      options: {
        filterable:["id", "name", "email"],
        filterByColumn: true,                   
        sortable: ["id", "name", "email"],
        templates: {
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          name: "Nome",
          email: "E-mail",
          actions: "Ações"
        },
        requestFunction: function(data) {
          let requestData = {};

           let query = this.$parent.$parent.query(data.query);
           requestData.params = data;
           requestData.params.query = "";
           requestData.params.with = [];

          return this.$http
              .get(this.url + '?' + query, requestData)
              .catch(
                  function(e) {
                      this.dispatch("error", e);
                  }.bind(this)
              );
        }
      },
      endPoint: "admins/"
    };
  },
  methods: {
    query: function (query) {
      let columns = {
        id: 'id',
        name: 'name',
        email: 'email',
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    }
  },
  components: {
    BaseCrud,
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Crud.vue